import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';

export const isFrenchPortal = (portal: Portal): portal is Portal.LogicImmo | Portal.SeLoger => {
    return portal === Portal.SeLoger || portal === Portal.LogicImmo;
};

export const isGermanPortal = (portal: Portal) => {
    return portal === Portal.ImmoWelt || portal === Portal.Immonet;
};

export const portalHasWebToAppBanner = (portal: Portal) => {
    return portal === Portal.ImmoWelt || portal === Portal.Immonet || portal === Portal.SeLoger;
};

export const correctBrandName: Partial<Record<Portal, string>> = {
    [Portal.ImmoWeb]: 'Immoweb',
    [Portal.ImmoWelt]: 'Immowelt',
    [Portal.Immonet]: 'Immonet',
    [Portal.LogicImmo]: 'Logic-Immo',
    [Portal.SeLoger]: 'SeLoger',
};
